import { configureStore } from '@reduxjs/toolkit';
import UpgradeDeviceReducer from './UpgradeDeviceStore';
import NewConnectionReducer from './NewConnectionStore';
import DevicesReportReducer from './DevicesReportStore';
import AuditTrailReducer from './AuditTrailStore';
import ImportReducer from './ImportStore';
import TerminateConnectionReducer from './TerminateConnectionStore';
import LiveNotificationsReducer from './LiveNotificationsStore';
import NotificationsCenterReducer from './NotificationsCenterStore';
import ESimManagerReducer from './ESimManagerStore';
import UserDetailsReducer from './UserDetailsStore';
import AssignDeviceReducer from './AssignDeviceStore';
import TransactionsReducer from './TransactionsStore';
import BannersReducer from './BannersStore';

export const Store = configureStore({
  reducer: {
    devicesReportReducer: DevicesReportReducer,
    upgradeDeviceReducer: UpgradeDeviceReducer,
    newConnectionReducer: NewConnectionReducer,
    auditTrailReducer: AuditTrailReducer,
    importReducer: ImportReducer,
    terminateConnectionReducer: TerminateConnectionReducer,
    liveNotificationsReducer: LiveNotificationsReducer,
    notificationsCenterReducer: NotificationsCenterReducer,
    eSimManagerReducer: ESimManagerReducer,
    userDetailsReducer: UserDetailsReducer,
    assignDeviceReducer: AssignDeviceReducer,
    transactionsReducer: TransactionsReducer,
    bannersReducer: BannersReducer,
  },
});
export type RootState = ReturnType<typeof Store.getState>;
